import Header from './components/Header';
import Hero from './components/Hero';
import Footer from './components/Footer';
import UpdatesSection from './sections/UpdatesSection';
import FeaturesSection from './sections/FeaturesSection';
import MediaSection from './sections/MediaSection';
import ContactSection from './sections/ContactSection';
import AboutSection from './sections/AboutSection';
import IndexSection from './sections/IndexSection';
import RankingSection from './sections/RankingSection';
import CommentsSection from './sections/CommentsSection';
import CardsSection from './sections/CardsSection';
import AppSection from './sections/AppSection';
import CarouselSection from './sections/CarouselSection';
import TopicsSection from './sections/TopicsSection';
import FaqSection from './sections/FaqSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <UpdatesSection />
        <FeaturesSection />
        <MediaSection />
        <ContactSection />
        <AboutSection />
        <IndexSection />
        <RankingSection />
        <CommentsSection />
        <CardsSection />
        <AppSection />
        <CarouselSection />
        <TopicsSection />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}